import { SalesForce } from "@/abilities/shop/types/salesforce-shop";
import { useGetSalesforceConfigLazyQuery } from "@/shared/services/graphql/generated/consumer-graph-types";

export const loadSalesforceShopConfig = async (): Promise<SalesForce.Config | null> => {
    const { load } = useGetSalesforceConfigLazyQuery();
    const data = await load();
    if (data && data.getSalesforceConfig) {
        const { graphUrl, id, shopServiceUrl, shopUrl } = data.getSalesforceConfig;
        if (!graphUrl || !id || !shopServiceUrl || !shopUrl) {
            return null;
        }
        return {
            graphUrl,
            id,
            shopServiceUrl,
            shopUrl,
        };
    } else {
        return null;
    }
};
